// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-FZ9cN6xf","leftInfo":"dp-MenE4H6E","icon":"dp-Spqk5nn2","infoContainer":"dp-EStQYiBG","name":"dp-qlQyu9ZD","orderInfo":"dp-0qW7eiYO","rightInfo":"dp-S2yKIPQU"};